module.exports = {
    A: { // Abilities
        USER: {
            LIST: 'user.list',
            CREATE: 'user.create',
            UPDATE: 'user.update',
            DELETE: 'user.delete',
            UPDATE_PASS: 'user.update.pass',
            UPDATE_ABIL: 'user.update.abil',
        },
        SERVICE: {
            LIST: 'service.list',
            CREATE: 'service.create',
            UPDATE: 'service.update',
            DELETE: 'service.delete',
        },
        PRODUCT: {
            LIST: 'product.list',
            CREATE: 'product.create',
            UPDATE: 'product.update',
            DELETE: 'product.delete',
        },
        LINE: {
            LIST: 'line.list',
            CREATE: 'line.create',
            UPDATE: 'line.update',
            DELETE: 'line.delete',
            LINK: 'line.link',
        },
        CUSTOMER: {
            LIST: 'customer.list',
            CREATE: 'customer.create',
            UPDATE: 'customer.update',
            DELETE: 'customer.delete',
            LINK: 'customer.link',
            LINKDIRECTION: 'customer.linkDirection',
            LINKEMAIL: 'customer.linkEmail'
        },
        DIRECTION: {
            LIST: 'direction.list',
            CREATE: 'direction.create',
            UPDATE: 'direction.update',
            DELETE: 'direction.delete',
            LINK: 'direction.link',
        },
        ORGANIZACION: {
            LIST: 'organization.list',
            CREATE: 'organization.create',
            UPDATE: 'organization.update',
            DELETE: 'organization.delete',
        },
        EMAIL: {
            LIST: 'email.list',
            CREATE: 'email.create',
            UPDATE: 'email.update',
            DELETE: 'email.delete',
            LINK: 'email.link',
        },
        PARAMETER: {
            UPDATE: 'parameter.update.',
        }/*,
        ABILITY: {
            LIST: 'parameter.list',
        }*/,
        DEPARTAMENT: {
            LIST: 'departament.list',
            CREATE: 'departament.create',
            UPDATE: 'departament.update',
            DELETE: 'departament.delete'
        },
        CENTER: {
            LIST: 'center.list',
            CREATE: 'center.create',
            UPDATE: 'center.update',
            DELETE: 'center.delete',
            LINK: 'center.link'
        },
        PROCESSLOG: {
            CREATE: 'processlog.create',
            LIST: 'processlog.list',
            DELETE: 'processlog.delete'
        },
        ERROR: {
            CREATE: 'error.create',
            LIST: 'error.list'
        },
        FLUJO: {
            CREATE: 'flujo.create',
            LIST: 'flujo.list',
            UPDATE: 'flujo.update',
            DELETE: 'flujo.delete'
        },
        PROYECTO: {
            CREATE: 'proyecto.create',
            LIST: 'proyecto.list',
            UPDATE: 'proyecto.update',
            DELETE: 'proyecto.delete'
        },
        SERVICIOSHOGARPLANES: {
            CREATE: 'servicioshogarplanes.create',
            LIST: 'servicioshogarplanes.list',
            UPDATE: 'servicioshogarplanes.update',
            DELETE: 'servicioshogarplanes.delete'
        },
        FLUJOSSTRUCTURE: {
            CREATE: "flujosStructure.create",
            LIST: "flujosStructure.list",
            UPDATE: "flujosStructure.update",
            DELETE: "flujosStructure.delete"
        },
        NIVELESSTRUCTURE: {
            CREATE: "nivelesStructure.create",
            LIST: "nivelesStructure.list",
            UPDATE: "nivelesStructure.update",
            DELETE: "nivelesStructure.delete"
        },
        FLUJOSADDRESSCOMPLEMENT: {
            CREATE: "flujosAddressComplement.create",
            LIST: "flujosAddressComplement.list",
            UPDATE: "flujosAddressComplement.update",
            DELETE: "flujosAddressComplement.delete"
        },

    },
    R: {
        DESARROLLADOR: 'desarrollador',
        SOPORTE: 'soporte'
    }
}